<template>
  <div class="brand">
    <div class="frame">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">
          构建多终端、全渠道线上零售商城助力企业快速进入电商新时代
        </div>
      </div>
      <img src="../../static/images/solution/yunyingkuangjia.png" alt="" />
    </div>

    <div class="system">
      <div class="big-title">
        <p>系统功能</p>
        <div class="line"></div>
        <div class="desc">
          站在用户立场，打造符合商家用户操作习惯与业务需求的电商系统对每一个功能都精雕细琢
        </div>
      </div>
      <div class="nav-top">
        <div
          class="nav-item"
          :class="{ active: navId == item.id }"
          v-for="item in navArr"
          :key="'nav' + item.id"
          @click="changeNav(item.id)"
        >
          {{ item.title }}
        </div>
      </div>
      <div
        class="nav-content"
        v-for="item in navArr"
        :key="item.id"
        v-show="navId == item.id"
      >
        <div class="content-left">
          <h2>{{ item.title }}</h2>
          <div class="ct-box">
            <div class="ct-item" v-for="s_item in item.list" :key="s_item.id" @mouseenter="onmouseEnter(s_item.id)" @mouseleave="onmouseLeave">
              <img v-if="enterId != s_item.id" :src="s_item.img" alt="" />
              <img v-else :src="s_item.activeImg" alt="">
              <p>{{ s_item.desc }}</p>
            </div>
          </div>
        </div>
        <img :src="item.img" alt="" />
      </div>
    </div>

    <div class="apply">
      <div class="big-title white">
        <p>适用行业</p>
        <div class="line"></div>
        <div class="desc">满足不同行业需求，为商家提供优质服务</div>
      </div>
      <div class="apply-box">
        <div class="apply-item">
          <img src="../../static/images/solution/baihuo.png" alt="" />
          <p>百货零售</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/huazhuangpin.png" alt="" />
          <p>化妆品</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/shuma.png" alt="" />
          <p>数码设备</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/fushi.png" alt="" />
          <p>服装服饰</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/shengxian.png" alt="" />
          <p>生鲜蔬菜</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/jiuye.png" alt="" />
          <p>酒业</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/muying.png" alt="" />
          <p>母婴用品</p>
        </div>
        <div class="apply-item">
          <img src="../../static/images/solution/qiche.png" alt="" />
          <p>汽车</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enterId:-1,
      navId: 0,
      navArr: [
        {
          id: 0,
          title: "消费者",
          img: require("../../static/images/solution/tu11.png"),
          list: [
            {
              id: 0,
              desc: "会员优惠劵",
              img: require("../../static/images/solution/1.png"),
              activeImg: require("../../static/images/solution/11.png"),
            },
            {
              id: 1,
              desc: "商品下单",
              img: require("../../static/images/solution/2.png"),
              activeImg: require("../../static/images/solution/12.png"),
            },
            {
              id: 2,
              desc: "订单详情",
              img: require("../../static/images/solution/3.png"),
              activeImg: require("../../static/images/solution/13.png"),
            },
            {
              id: 3,
              desc: "团购秒杀",
              img: require("../../static/images/solution/4.png"),
              activeImg: require("../../static/images/solution/14.png"),
            },
            {
              id: 4,
              desc: "附近门店",
              img: require("../../static/images/solution/5.png"),
              activeImg: require("../../static/images/solution/15.png"),
            },
            {
              id: 5,
              desc: "评论分享",
              img: require("../../static/images/solution/6.png"),
              activeImg: require("../../static/images/solution/16.png"),
            },
            {
              id: 6,
              desc: "礼品劵",
              img: require("../../static/images/solution/7.png"),
              activeImg: require("../../static/images/solution/17.png"),
            },
            {
              id: 7,
              desc: "LSB定位",
              img: require("../../static/images/solution/8.png"),
              activeImg: require("../../static/images/solution/18.png"),
            },
            {
              id: 8,
              desc: "搜索商品",
              img: require("../../static/images/solution/9.png"),
              activeImg: require("../../static/images/solution/19.png"),
            },
            {
              id: 9,
              desc: "分销结佣",
              img: require("../../static/images/solution/10.png"),
              activeImg: require("../../static/images/solution/20.png"),
            },
          ],
        },
        {
          id: 1,
          title: "店铺管理员",
          img: require("../../static/images/solution/tu22.png"),
          list: [
            {
              id: 0,
              desc: "商品管理",
              img: require("../../static/images/solution/21.png"),
              activeImg: require("../../static/images/solution/31.png"),
            },
            {
              id: 1,
              desc: "售后管理",
              img: require("../../static/images/solution/22.png"),
              activeImg: require("../../static/images/solution/32.png"),
            },
            {
              id: 2,
              desc: "投诉管理",
              img: require("../../static/images/solution/23.png"),
              activeImg: require("../../static/images/solution/33.png"),
            },
            {
              id: 3,
              desc: "营销活动管理",
              img: require("../../static/images/solution/24.png"),
              activeImg: require("../../static/images/solution/34.png"),
            },
            {
              id: 4,
              desc: "店铺管理",
              img: require("../../static/images/solution/25.png"),
              activeImg: require("../../static/images/solution/35.png"),
            },
            {
              id: 5,
              desc: "会员管理",
              img: require("../../static/images/solution/26.png"),
              activeImg: require("../../static/images/solution/36.png"),
            },
            {
              id: 6,
              desc: "订单管理",
              img: require("../../static/images/solution/27.png"),
              activeImg: require("../../static/images/solution/37.png"),
            },
            {
              id: 7,
              desc: "统计管理",
              img: require("../../static/images/solution/28.png"),
              activeImg: require("../../static/images/solution/38.png"),
            },
            {
              id: 8,
              desc: "评价管理",
              img: require("../../static/images/solution/29.png"),
              activeImg: require("../../static/images/solution/39.png"),
            },
            {
              id: 9,
              desc: "物流管理",
              img: require("../../static/images/solution/30.png"),
              activeImg: require("../../static/images/solution/40.png"),
            },
          ],
        },
        {
          id: 2,
          title: "平台管理员",
          img: require("../../static/images/solution/tu33.png"),
          list: [
            {
              id: 0,
              desc: "用户管理",
              img: require("../../static/images/solution/41.png"),
              activeImg: require("../../static/images/solution/50.png"),
            },
            {
              id: 1,
              desc: "商城设置",
              img: require("../../static/images/solution/42.png"),
              activeImg: require("../../static/images/solution/51.png"),
            },
            {
              id: 2,
              desc: "物流管理",
              img: require("../../static/images/solution/43.png"),
              activeImg: require("../../static/images/solution/52.png"),
            },
            {
              id: 3,
              desc: "订单管理",
              img: require("../../static/images/solution/44.png"),
              activeImg: require("../../static/images/solution/53.png"),
            },
            {
              id: 4,
              desc: "商城装修",
              img: require("../../static/images/solution/45.png"),
              activeImg: require("../../static/images/solution/54.png"),
            },
            {
              id: 5,
              desc: "商品投诉",
              img: require("../../static/images/solution/46.png"),
              activeImg: require("../../static/images/solution/55.png"),
            },
            {
              id: 6,
              desc: "入驻审核",
              img: require("../../static/images/solution/47.png"),
              activeImg: require("../../static/images/solution/56.png"),
            },
            {
              id: 7,
              desc: "财务管理",
              img: require("../../static/images/solution/48.png"),
              activeImg: require("../../static/images/solution/57.png"),
            },
            {
              id: 8,
              desc: "营销功能",
              img: require("../../static/images/solution/49.png"),
              activeImg: require("../../static/images/solution/58.png"),
            },
          ],
        },
      ],
    };
  },
  methods: {
    changeNav(id) {
      this.navId = id;
    },
    onmouseEnter(id){
      this.enterId = id;
    },
    onmouseLeave(){
      this.enterId = -1;
    }
  },
};
</script>

<style lang="stylus" scoped>
.brand {
  padding: 88px 0 160px;
}

.frame {
  width: 1400px;
  margin: 0 auto;
}

.system {
  padding-top: 80px;
  width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .nav-top {
    display: flex;

    .nav-item {
      text-align: center;
      line-height: 60px;
      width: 220px;
      height: 60px;
      background: #F5F5F5;
      font-size: 18px;
      font-weight: bold;
      color: #666666;
    }

    .nav-item.active {
      position:relative;
      background: #FFC000;
      color: #333333;
    }

    .nav-item.active:before {
      content: '';
      position: absolute;
      top:50px;
      left:85px;
      width: 0;
      height: 0;
      border-width: 22px;
      border-style: solid;
      border-color: #FFC000 transparent transparent transparent;
    }
  }

  .nav-content {
    display: flex;
    justify-content: space-between;
    margin: 50px 0 80px;
    width: 1400px;
    height: 444px;
    background: #F5F5F5;

    .content-left {
      margin-left: 24px;

      h2 {
        font-size: 30px;
        font-weight: bold;
        color: #333333;
        margin: 10px 0 32px;
      }

      .ct-box {
        display: flex;
        flex-wrap: wrap;
      }

      .ct-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 148px;
        height: 148px;
        background: #FFFFFF;
        margin-right: 24px;
        margin-bottom: 24px;

        p {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          margin-top: 30px;
        }
      }
    }
  }
}

.apply {
  width: 1400px;
  height: 412px;
  padding-top: 80px;
  margin: 0 auto;
  background: url('../../static/images/solution/tu2@2x.png');

  .apply-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0 60px;

    .apply-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 160px;
    }

    p {
      color: #fff;
      text-align: center;
      margin-top: 25px;
    }
  }
}

.big-title.white {
  p {
    color: #fff;
  }

  .desc {
    color: #fff;
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }

  .desc {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin: 22px 0 58px;
    line-height: 28px;
  }
}

.small-title {
  .frist-line {
    display: flex;
    align-items: center;
  }

  h2 {
    font-weight: bold;
    margin: 0 0 0 12px;
    font-size: 22px;
    font-weight: bold;
    color: #333333;
  }

  p {
    font-size: 18px;
    font-weight: 500;
    color: #666666;
    padding: 17px 0 0 40px;
  }
}

.phone-title {
  font-size: 22px;
  font-weight: 800;
  color: #333333;
  margin: 80px 0 54px;
}

.second-title {
  .frist-line {
    font-size: 22px;
    font-weight: 800;
    color: #333333;
    margin-top: 73px;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    margin-top: 16px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/SolutionBrand.vue